import { render, staticRenderFns } from "./EvaluationOfInformation.vue?vue&type=template&id=36b3ad7c&scoped=true"
import script from "./EvaluationOfInformation.vue?vue&type=script&lang=js"
export * from "./EvaluationOfInformation.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/radio-button.css?vue&type=style&index=0&id=36b3ad7c&prod&scoped=true&lang=css&external"
import style1 from "./EvaluationOfInformation.vue?vue&type=style&index=1&id=36b3ad7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3ad7c",
  null
  
)

export default component.exports